/* unplugin-vue-components disabled */import { render } from "./AIAdminPanel.vue?vue&type=template&id=01eeebf9&scoped=true&ts=true"
import script from "./AIAdminPanel.vue?vue&type=script&lang=ts"
export * from "./AIAdminPanel.vue?vue&type=script&lang=ts"

import "./AIAdminPanel.vue?vue&type=style&index=0&id=01eeebf9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01eeebf9"]])

export default __exports__